// extracted by mini-css-extract-plugin
export default {"buttonHeader":"StudentGroup_buttonHeader__i1LjU","studentGroup":"StudentGroup_studentGroup__xPZev"};